import * as React from 'react';
import { Component } from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ButtonCallToAction, ButtonTertiary } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { AdministrationUserEditProps } from 'app/area/administration/edit/user/types';
import { ids } from 'app/area/administration/constants';
import { UserEditMenu } from 'app/area/administration/edit/user/user-edit-menu/user-edit-menu';
import { TopPanel } from 'app/area/administration/edit/components';
import { createFormatters, isDisabled } from 'app/infrastructure/data/date';

import styles from 'app/area/administration/edit/edit.scss';
import { DateFormatters } from 'app/infrastructure/data/types';
import { Tag } from 'app/components/tag';
import { ComplexValue } from 'app/types-shared';
import { getTechnicalUserValue } from 'app/area/administration/edit/user/helpers';

export class UserStickyHeader extends Component<AdministrationUserEditProps> {
  private formatters: DateFormatters;

  public constructor(props: AdministrationUserEditProps) {
    super(props);
    this.formatters = createFormatters(props.sharedState.locale);
  }

  private onCancel = () => {
    navigate.toAdminUsersList(false);
  };

  public render() {
    const { accessPerson, data, translation, fetchingSaveUser, optionsFetching,
      editMode, validation: serverValidation, clearValidation, showUserEditMenu,
      hideDetails, formValues: { disabled } = {} } = this.props;
    const { params: { actionType } = {},
      sharedState: {
        id: loggedUserId = undefined,
        access: {
          adminPanel: {
            user: {
              create: createUserAccess = false
            } = {}
          } = {}
        } = {}
      } = {} } = this.props;

    return <StickyHeader className={`headerpanel ${styles.headerWrapper} ${styles.headerSticky} header-panel`}
      rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary onClick={this.onCancel}>{translation.cancel}</ButtonTertiary>

          {editMode && <ButtonCallToAction
            id={ids.users.save_button}
            onClick={this.props.onSave}
            disabled={fetchingSaveUser || optionsFetching}>
            {this.props.saveButtonText}
          </ButtonCallToAction>}
        </StickyHeaderButtonContainer>

        {showUserEditMenu && <UserEditMenu
          id={data.id}
          optionsFetching={optionsFetching}
          personId={data.personId}
          name={data.name}
          technical={data.technical}
          accessPerson={accessPerson}
          loggedUserId={loggedUserId}
          translation={translation}
          validation={serverValidation}
          clearValidation={clearValidation}
          canDuplicate={createUserAccess}
          onDelete={this.props.deleteUser}
          onChangePassword={this.props.changePassword}
          onChangePersonId={this.props.changePersonId}
          onSaveDatabaseAccount={this.props.saveDatabaseAccount}
          onResetDatabaseAccount={this.props.resetDatabaseAccount}
          onDeleteDatabaseAccount={this.props.deleteDatabaseAccount}
          onLoadUser={this.props.loadUser}
          fetching={this.props.fetchingLoadUser || this.props.fetchingChangePersonId || this.props.fetchingDatabaseAccount}
        />}
      </>
      }>
      <div className={styles.content}>
        <div className={styles.info}>
          {this.props.showUserId ? <span className={styles.id}>
            #{this.props.id}
          </span> : null}
          {this.props.title &&
            <span className={styles.title} aria-hidden={true}>
              {this.props.title}
            </span>}
        </div>
        <div className={styles.rightSide}>
          {isDisabled(new Date(disabled as string)) ? <Tag className={styles.tag}>{translation.disabled}</Tag> : null}
          {getTechnicalUserValue(
            this.props.data?.userType?.value,
            (this.props.formValues?.userType as ComplexValue<number>)?.value,
            this.props.data?.technical,
            actionType
          ) ? <Tag className={styles.tag}>{translation.technical_user}</Tag>
            : null}
        </div>
      </div>
      <TopPanel
        hideDetails={hideDetails}
        data={data}
        translation={translation}
        formatters={this.formatters}
      />
    </StickyHeader>;
  }
}
